/**
 * Aide / attendant task note (Phase 20D, AIDE_TASKS): HHA and personal care / CFC attendant visits.
 * Each planned task is Done, Refused or Not needed; attendant visits record minutes per task done
 * (billed in 15-minute units). Observations go to the supervising clinician.
 */

import { BaseEntryData } from './chart-entry.dto';

export const AIDE_TASK_STATUSES = ['DONE', 'REFUSED', 'NOT_NEEDED'] as const;
export type AideTaskStatus = typeof AIDE_TASK_STATUSES[number];

export interface AideTask {
  task: string;
  status: AideTaskStatus;
  /** 1–480; required on a done task of an attendant visit */
  minutes?: number;
  /** Required when the task was refused */
  note?: string;
}

export interface AideTasksData extends BaseEntryData {
  tasks: AideTask[];
  observations?: string;
  reportedToSupervisor?: boolean;
  notes?: string;
}
